import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import type { UpdateEvents, ViewInput } from "../../common/types.ts";

const updateReportCardLeaderboard = async (
	inputs: ViewInput<"reportCardLeaderboard">,
	updateEvents: UpdateEvents,
	state: {
		season?: number;
	},
) => {
	if (
		updateEvents.includes("firstRun") ||
		updateEvents.includes("newPhase") ||
		updateEvents.includes("gameSim") ||
		inputs.season !== state.season
	) {
		const teamSeasons = await idb.getCopies.teamSeasons(
			{ season: inputs.season },
			"noCopyCache",
		);

		const ranked = teamSeasons
			.filter((ts) => ts.reportCard)
			.sort(
				(a, b) => (b.reportCard?.gmScore ?? 0) - (a.reportCard?.gmScore ?? 0),
			);

		const teams = ranked.map((ts, i) => ({
			rank: i + 1,
			tid: ts.tid,
			abbrev: ts.abbrev,
			region: ts.region,
			name: ts.name,
			grade: ts.reportCard!.grade,
			gmScore: ts.reportCard!.gmScore,
			champion: ts.reportCard!.champion,
			won: ts.won,
			lost: ts.lost,
			projectedWins: ts.projectedWins,
			playoffRoundsWon: ts.playoffRoundsWon,
		}));

		return {
			season: inputs.season,
			teams,
			userTid: g.get("userTid"),
			numPlayoffRounds: g.get("numGamesPlayoffSeries", inputs.season).length,
		};
	}
};

export default updateReportCardLeaderboard;
